export enum EnvName {
	Local = 'local',
	Staging = 'stg',
	Production = 'prod',
	Automation = 'automation',
	Other = 'other',
	Uat = 'uat',
}

export interface AppEnv {
	appEnv: EnvName;
	patchVersion: number;
	versionName: string;
	apiHost?: string;
	logErrors?: boolean;
	rsa_public_key?: string;
	sessionTimeoutInSeconds?: number;
	defaultCountryCode?: string;
	pageLimit?: number[];
	sentryDsn?: string;
	scopes?: string[];
	accessToken?: string;
}
